
import { Action, Component, namespace, Vue } from 'bits/vue'
import OzIcon from 'library/v4/components/OzIcon.vue'
import { getAnchorFromElement } from 'library/v4/components/OzPopoverModal.vue'
import OzTextButton, { OzTextButtonColorScheme } from 'library/v4/components/OzTextButton.vue'

const wallCollectionsStore = namespace('wallCollections')
const browserStore = namespace('browser')

@Component({
  components: {
    OzTextButton,
    OzIcon,
  },
})
export default class SurfaceNavBookmarkButton extends Vue {
  OzTextButtonColorScheme = OzTextButtonColorScheme
  @Action bookmarkWallAndNotify
  @Action openEditBookmarksDialog

  @browserStore.Getter windowWidth!: number
  @wallCollectionsStore.Getter isActiveWallBookmarked

  get iconSize(): number {
    const oldSmartphoneBreakpoint = 480
    return this.windowWidth <= oldSmartphoneBreakpoint ? 24 : 16
  }

  editBookmarks(): void {
    const vue = this.$refs.bookmarkButton as OzTextButton
    const el = vue?.$el
    const popoverAnchor = el
      ? {
          position: 'top',
          ...getAnchorFromElement(el),
        }
      : null
    this.openEditBookmarksDialog(popoverAnchor)
  }
}
